import { Base64 } from 'js-base64';
import { SimpleQueryParser, QueryParser } from './SimpleQueryParser';

export interface AuthParser {
  parse(queryParam: string): any;
}

export class UrlBase64JsonParser implements AuthParser {
  private parser: QueryParser;

  constructor(queryParser: QueryParser = new SimpleQueryParser()) {
    this.parser = queryParser;
  }

  public parse(queryParam: string): any {
    const param = this.parser.getQueryParam(queryParam);
    let json;

    if (param) {
      const jsonContent = Base64.decode(param);

      try {
        json = JSON.parse(jsonContent);
      } catch (e) {
        console.error(
          `Content of '${queryParam}' is either wrong base64 encoded or contains invalid JSON.`
        );
      }
    }

    return json;
  }
}
